import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const fetchCampaigns = async (user, page, limit) => {
    try {
        const { data } = await axios.get(`${API_BASE_URL}/campaigns/list?page=${page}&limit=${limit}`, buildHeaders(user))
        return data
    } catch (error) {
        console.error(error)
        throw error
    }
}


export const endCampaign = async (user, campaign_id) => {
    try {
        const { data } = await axios.post(`${API_BASE_URL}/campaigns/${campaign_id}/end`, {},
            buildHeaders(user))
        return data
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const updateCampaign = async (user, campaign_id, campaign) => {
    try {
        const { data } = await axios.put(`${API_BASE_URL}/campaigns/${campaign_id}`, campaign,
            buildHeaders(user))
        return data
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const createCampaign = async (user, campaign) => {
    try {
        const { data } = await axios.post(`${API_BASE_URL}/campaigns`, campaign,
            buildHeaders(user))
        return data
    } catch (error) {
        console.error(error)
        throw error
    }
}

